import CopyrightContainer from "Layout/CopyrightContainer/CopyrightContainer";
import React from "react";
import classes from "./AuthenticationLayout.module.css";
import { Outlet } from "react-router-dom";
import Navbar from "Layout/Navbar/Navbar";

const AuthenticationLayout = ({frontendInfo}) => {
  return (
    <>
      <Navbar frontendInfo={frontendInfo}/>
      <main className={classes.wrapper}>
        <div className={classes.outlet}>
          <Outlet />
        </div>
        <CopyrightContainer />
      </main>
    </>
  );
};

export default AuthenticationLayout;
